import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressCurrencySiteSettingsApiV1SiteCurrencySettingsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/_api/currency-site-settings',
        destPath: '',
      },
    ],
    'currency-converter.wixapps.net': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/currency-converter-settings',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/settings/v1/currencies/site',
        destPath: '/v1/currencies/site',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_currency-converter_site-settings';

/**
 * Sets the list of currencies that can be displayed on the site.
 *
 * When you set currencies for a site, visitors can view prices in any of these currencies.
 * Prices are automatically converted using up-to-date exchange rates.
 * The supplied list completely replaces the previous currency list.
 *
 * To disable currency conversion entirely, pass an empty array.
 */
export function setCurrencies(payload: object): RequestOptionsFactory<any> {
  function __setCurrencies({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.settings.v1.site_currency',
      method: 'PUT' as any,
      methodFqn:
        'com.wixpress.currency.site.settings.api.v1.SiteCurrencySettings.SetCurrencies',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCurrencySiteSettingsApiV1SiteCurrencySettingsUrl({
        protoPath: '/v1/currencies/site',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __setCurrencies;
}

/**
 * Retrieves the list of currencies that can be displayed on the site.
 *
 * Returns all currencies that are currently enabled for the site.
 * Visitors can view prices in any of these currencies.
 */
export function getCurrencies(payload: object): RequestOptionsFactory<any> {
  function __getCurrencies({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.settings.v1.site_currency',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.currency.site.settings.api.v1.SiteCurrencySettings.GetCurrencies',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCurrencySiteSettingsApiV1SiteCurrencySettingsUrl({
        protoPath: '/v1/currencies/site',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getCurrencies;
}
